const Choices = require("choices.js");
document.addEventListener("DOMContentLoaded", function () {
	initSpoilerSections(document.querySelectorAll(".spoiler-section"));
	initArrow(document.querySelector(".mobile-summary .arrow"), document.querySelector(".calculator-summary"));
});
window.initCalculator = function (defaultVals, configVals) {
	return new Calculator(defaultVals, configVals)
}

function initSpoilerSections(sects) {
	if (sects.length) {
		sects.forEach((sect) => {
			sect.querySelector(".toggler")
				.addEventListener("click", function () {
					this.classList.toggle("active");
					$(sect.querySelector(".fields-area"))
						.slideToggle();
				});
		});
	}
}

function convertCoffeeToChoices() {
	let toReturn = [];
	window.coffeeArr.forEach((item) => {
		toReturn.push({
			value: item.cost,
			label: `<div>${item.title}</div><div>${item.cost} $/кг</div>`,
		});
	});
	toReturn.push({
		value: "enable",
		label: `Ввести свое значение`,
	});
	return toReturn;
}

function initArrow(arrow, summary) {
	if (arrow && summary) {
		let remember = true;
		let lastScroll;
		window.addEventListener("scroll", function () {
			if (remember) {
				lastScroll = this.scrollY;
			}
		});
		arrow.addEventListener("click", function () {
			if (remember) {
				remember = !remember;
				summary.scrollIntoView();
				this.classList.add("on-summary");
			} else {
				this.classList.remove("on-summary");
				window.scrollTo(0, lastScroll);
				remember = !remember;
			}
		});
	}
}
class Calculator {
	constructor(defaultValues, initialValues) {
		this.initialValues = initialValues ? initialValues : {}
		this.defaultValues = defaultValues;
		this.values = JSON.parse(JSON.stringify(defaultValues))
		this.nodes = {
			fields: {
				pricing: {
					costOfRaw: undefined,
					plannedSellingPrice: undefined,
				},
				production: {
					roasterLoading: undefined,
					workingDays: undefined,
					actualSales: undefined,
				},
				directCosts: {
					package: undefined,
					label: undefined,
					gas: undefined,
					rent: undefined,
					deliveryToProduction: undefined,
					deliveryToCustomers: undefined,
					secondaryPackaging: undefined,
					colosorter: undefined,
					cupping: undefined,
				},
				indirectCosts: {
					employeeSalaries: undefined,
					rentOfSpace: undefined,
					depreciation: undefined,
					water: undefined,
					electricity: undefined,
					buisnesTrips: undefined,
					samples: undefined,
					borrowedFunds: undefined,
					customerLending: undefined,
					communication: undefined,
					digitalService: undefined,
					householdExpences: undefined,
					bankingServise: undefined,
					marketing: undefined,
				},
			},
			consts: {
				pricing: {
					costOfRaw: undefined,
					USDRate: undefined,
					recommendedMinimunPrice: undefined,
					tax: undefined,
				},
				production: {
					kgPerShift: undefined,
					productionLimit: undefined,
				},
				directCosts: {
					directCosts: undefined,
					greenCoffee: undefined,
					acquiring: undefined,
					cropster: undefined,
				},
				indirectCosts: {
					indirectCosts: undefined,
				},
				summary: {
					productionLimit: undefined,
					actualSales: undefined,
					busyness: undefined,
					profit: undefined,
					maxProfit: undefined,
					actualProfit: undefined,
				},
			}
		}
		for (const [keyParent, valueParent] of Object.entries(this.nodes.fields)) {
			for (const [key, value] of Object.entries(valueParent)) {
				let node = document.querySelector(`[name="${key}"]`);
				this.nodes.fields[keyParent][key] = node;
				node.addEventListener("input", function () {
					let val = this.value;
					if (isNaN(val)) {
						val = val.replace(/[^0-9\.]/g, "");
						if (val.split(".")
							.length > 2) val = val.replace(/\.+$/, "");
					}
					this.value = val;
					if (this.dataset.notnull) {
						if (val > 0) {
							this.setCustomValidity("");
						} else {
							this.setCustomValidity("Введите значение больше нуля");
							this.reportValidity();
						}
					}
				});
				node.addEventListener("input", () => {
					this.calc();
				});
				node.addEventListener("change", () => {
					this.calc();
				});
			}
		}
		for (const [keyParent, valueParent] of Object.entries(this.nodes.consts)) {
			for (const [key, value] of Object.entries(valueParent)) {
				let node = document.querySelectorAll(`[data-name="${key}"]`);
				this.nodes.consts[keyParent][key] = node;
			}
		}
		this.collectValues()
		this.initChoices()
		this.setInitialValues()
		this.initBindedSelect()
		this.calc();
		this.exportAll()
	}
	collectValues() {
		for (const key1 in this.values) {
			if (key1 in this.initialValues) {
				for (const key2 in this.values[key1]) {
					if (key2 in this.initialValues[key1]) {
						for (const key3 in this.values[key1][key2]) {
							if (key3 in this.initialValues[key1][key2]) {
								if (this.initialValues[key1][key2][key3] !== undefined) {
									this.values[key1][key2][key3] = this.initialValues[key1][key2][key3];
								}
							}
						}
					}
				}
			}
		}
	}
	setInitialValues() {
		for (const [keyParent, valueParent] of Object.entries(this.nodes.fields)) {
			for (const [key, node] of Object.entries(valueParent)) {
				if (key == 'buisnesTrips') {
					this.setValue("fields", keyParent, key, this.values.fields[keyParent][key] * +this.values.consts["pricing"]['USDRate'])
					continue
				}
				this.setValue("fields", keyParent, key, this.values.fields[keyParent][key])
			}
		}
		for (const [keyParent, valueParent] of Object.entries(this.nodes.consts)) {
			for (const [key, node] of Object.entries(valueParent)) {
				this.setValue("consts", keyParent, key, this.values.consts[keyParent][key])
			}
		}
	}
	initBindedSelect() {
		document.querySelectorAll(`[data-change]`)
			.forEach((changer) => {
				let targetNode = document.querySelector(`[name="${changer.dataset.change}"]`);
				changer.addEventListener("change", function () {
					if (this.value == "enable") {
						targetNode.removeAttribute("disabled");
					} else {
						targetNode.setAttribute("disabled", "");
						targetNode.value = this.value;
						targetNode.dispatchEvent(new Event("change"));
					}
				});
				if (changer.value == "enable") {
					targetNode.removeAttribute("disabled");
				}
			});
	}
	initChoices() {
		for (const [keyParent, valueParent] of Object.entries(this.nodes.consts)) {
			for (const [key, value] of Object.entries(valueParent)) {
				for (const [item, node] of Object.entries(value)) {
					if (node.tagName == "SELECT") {
						if (node.name == "costOfRaw") {
							this.nodes.consts[keyParent][key] = [new Choices(node, {
								itemSelectText: "",
								searchEnabled: false,
								shouldSort: false,
								choices: convertCoffeeToChoices(),
							})];
						} else {
							this.nodes.consts[keyParent][key] = [new Choices(node, {
								itemSelectText: "",
								searchEnabled: false,
								shouldSort: false,
							})];
						}
					}
				}
			}
		}
		for (const [keyParent, valueParent] of Object.entries(this.nodes.fields)) {
			for (const [key, node] of Object.entries(valueParent)) {
				if (node.tagName == "SELECT") {
					this.nodes.fields[keyParent][key] = [new Choices(node, {
						itemSelectText: "",
						searchEnabled: false,
						shouldSort: false,
					})];
				}
			}
		}
	}
	getValue(section, group, name) {
		if (this.nodes[section][group][name] instanceof Element || this.nodes[section][group][name] instanceof NodeList) {
			if (this.nodes[section][group][name].tagName == "SELECT" || this.nodes[section][group][name].tagName == "INPUT") {
				return new Number(+this.nodes[section][group][name].value.replace(/\s/g, ""))
					.toFixed(2);
			} else {
				let googleFontsNodes = this.nodes[section][group][name][0].querySelectorAll('font')
				if (googleFontsNodes.length) {
					console.log(googleFontsNodes[googleFontsNodes.length - 1]);

					return new Number(googleFontsNodes[googleFontsNodes.length - 1].innerHTML.replace(/\s/g, ""))
						.toFixed(2);
				}
				return new Number(+this.nodes[section][group][name][0].innerHTML.replace(/\s/g, ""))
					.toFixed(2);
			}
		} else {
			return new Number(this.nodes[section][group][name][0].getValue(true))
				.toFixed(2)
		}
	}
	setValue(section, group, name, value) {
		if (this.nodes[section][group][name] instanceof NodeList) {
			this.nodes[section][group][name].forEach((node) => {
				node.innerHTML = new Number(Math.ceil(value * 100) / 100)
					.toFixed(2)
					.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
			})
		} else {
			if (this.nodes[section][group][name] instanceof Array) {
				this.nodes[section][group][name][0].setChoiceByValue(value.replace(".00", ""));
			} else {
				if (this.nodes[section][group][name] instanceof Element) {
					this.nodes[section][group][name].value = new Number(value)
						.toFixed(2);
				} else {
					this.nodes[section][group][name].setChoiceByValue(value.replace(".00", ""));
				}
			}
		}
	}
	summOfGroup(section, group) {
		let buf = 0;
		for (const [key, value] of Object.entries(this.nodes[section][group])) {
			if (value.dataset.sumexclude) {
				continue;
			}
			buf += +this.getValue(section, group, key);
		}
		return buf;
	}
	setStatus() {
		let moneyStatuses = [{
			color: "red",
			text: "С такой экономикой не стоит начинать кофейный бизнес.",
			start: 0
		}, {
			color: "orange",
			text: "Лучше, чем пособие по безработице, выше, чем прожиточный минимум, но ниже средней заработной платы по РФ.",
			start: 15000
		}, {
			color: "orange",
			text: "Выше, чем средняя зарплата в Удмуртии, но на Чукотке больше возможностей.",
			start: 45000
		}, {
			color: "yellow",
			text: "Уровень дохода приближенный к среднемесячной заработной плате в нефтегазовом секторе, финансовых услугах и IT, но кофе можно вполне рассмотреть как новую точку приложения творческой энергии.",
			start: 90000,
			// textBGColor: "rgba(207, 149, 0, 0.4)"
		}, {
			color: "green",
			text: "Доход менеджера среднего и высшего звена в крупной компании все еще может быть предпочтительнее, но кофе – значительно более приятный бизнес.",
			start: 150000
		}, {
			color: "green",
			text: "Вы – супермолодец!",
			start: 500000
		}]
		let timeStatuses = [{
			color: "green",
			text: "Идеальнеый старт",
			start: 0
		}, {
			color: "orange",
			text: "Комфортно, но пора подумать о найме сотрудника",
			start: 5
		}, {
			color: "red",
			text: "Если не нанять обжарщика, с ростером можно оформлять официальный союз: cемья будет видеть вас редко",
			start: 10
		}, {
			color: "red",
			text: "Число дней работы не может превышать число дней в месяце!",
			start: 30
		}]
		let colors = {
			orange: "#F07A24",
			red: "#da251c",
			yellow: "#FDCD23",
			green: "#75b861",
		}
		let calcStatus = (currentValue, statuses) => {
			if (currentValue < statuses[0].start) {
				return statuses[0]
			}
			for (let index = 0; index < statuses.length; index++) {
				if (statuses[index].start > currentValue) {
					return statuses[index - 1]
				}
			}
			return statuses[statuses.length - 1]
		}
		let setRowStatus = (row, value, statuses) => {
			let currentStatus = calcStatus(value, statuses)
			let textWrapper = row.querySelector('.row-info .info-notify')
			let textNode = row.querySelector('.row-info .info-notify span')
			if (currentStatus.textBGColor) {
				textWrapper.style.background = `${currentStatus.textBGColor}`
			}
			row.style.background = `${colors[currentStatus.color]}`
			textNode.innerHTML = currentStatus.text
		}
		let setBlockStatus = (block, value, statuses) => {
			let currentStatus = calcStatus(value, statuses)
			block.style.color = `${colors[currentStatus.color]}`
		}
		let rows = document.querySelectorAll(".colored-row");
		let blocks = document.querySelectorAll(".mobile-summary .value");
		setRowStatus(rows[1], this.getValue("consts", "summary", "actualProfit"), moneyStatuses)
		setRowStatus(rows[0], this.getValue("consts", "summary", "busyness"), timeStatuses)
		setBlockStatus(blocks[1], this.getValue("consts", "summary", "actualProfit"), moneyStatuses)
		setBlockStatus(blocks[0], this.getValue("consts", "summary", "busyness"), timeStatuses)
	}
	exportAll() {
		let toretun = {
			fields: {
				pricing: {
					costOfRaw: undefined,
					plannedSellingPrice: undefined,
				},
				production: {
					roasterLoading: undefined,
					workingDays: undefined,
					actualSales: undefined,
				},
				directCosts: {
					package: undefined,
					label: undefined,
					gas: undefined,
					rent: undefined,
					deliveryToProduction: undefined,
					deliveryToCustomers: undefined,
					secondaryPackaging: undefined,
					colosorter: undefined,
					cupping: undefined,
				},
				indirectCosts: {
					employeeSalaries: undefined,
					rentOfSpace: undefined,
					depreciation: undefined,
					water: undefined,
					electricity: undefined,
					buisnesTrips: undefined,
					samples: undefined,
					borrowedFunds: undefined,
					customerLending: undefined,
					communication: undefined,
					digitalService: undefined,
					householdExpences: undefined,
					bankingServise: undefined,
					marketing: undefined,
				},
			},
			consts: {
				pricing: {
					costOfRaw: undefined,
					USDRate: undefined,
					recommendedMinimunPrice: undefined,
					tax: undefined,
				},
				production: {
					kgPerShift: undefined,
					productionLimit: undefined,
				},
				directCosts: {
					directCosts: undefined,
					greenCoffee: undefined,
					acquiring: undefined,
					cropster: undefined,
				},
				indirectCosts: {
					indirectCosts: undefined,
				},
				summary: {
					productionLimit: undefined,
					actualSales: undefined,
					busyness: undefined,
					profit: undefined,
					maxProfit: undefined,
					actualProfit: undefined,
				},
			}
		}
		for (const key1 in toretun) {
			for (const key2 in toretun[key1]) {
				for (const key3 in toretun[key1][key2]) {
					if (this.getValue(key1, key2, key3) != this.defaultValues[key1][key2][key3]) {
						toretun[key1][key2][key3] = this.getValue(key1, key2, key3)
					}
				}
			}
		}
		for (const key1 in toretun) {
			for (const key2 in toretun[key1]) {
				for (const key3 in toretun[key1][key2]) {
					if (toretun[key1][key2][key3] == undefined) {
						delete toretun[key1][key2][key3]
					}
				}
				if (Object.keys(toretun[key1][key2])
					.length == 0) {
					delete toretun[key1][key2]
				}
			}
			if (Object.keys(toretun[key1])
				.length == 0) {
				delete toretun[key1]
			}
		}
		return toretun
	}
	calc() {
		for (const [keyParent, valueParent] of Object.entries(this.nodes.fields)) {
			for (const [key, value] of Object.entries(valueParent)) {
				if (value instanceof Element) {
					if (!value.checkValidity()) {
						value.reportValidity();
						return;
					}
				}
			}
		}
		// рекомендуемая цена продажи
		this.setValue("consts", "pricing", "recommendedMinimunPrice", this.getValue("fields", "pricing", "costOfRaw") * this.getValue("consts", "pricing", "USDRate") * 3);
		// налог
		this.setValue("consts", "pricing", "tax", this.getValue("fields", "pricing", "plannedSellingPrice") * 0.06);
		// кг в смену
		this.setValue("consts", "production", "kgPerShift", this.getValue("fields", "production", "roasterLoading") * 15.36);
		// Производственный лимит
		this.setValue("consts", "production", "productionLimit", this.getValue("fields", "production", "workingDays") * this.getValue("consts", "production", "kgPerShift"));
		// зеленый кофе с учетом ужарки
		this.setValue("consts", "directCosts", "greenCoffee", this.getValue("fields", "pricing", "costOfRaw") * this.getValue("consts", "pricing", "USDRate") * 1.2);
		// эквайринг
		this.setValue("consts", "directCosts", "acquiring", this.getValue("fields", "pricing", "plannedSellingPrice") * 0.025);
		// кропстер
		this.setValue("consts", "directCosts", "cropster", this.getValue("consts", "pricing", "USDRate") * 0.35);
		// прямые затраты
		this.setValue("consts", "directCosts", "directCosts", this.summOfGroup("fields", "directCosts") + +this.getValue("consts", "directCosts", "greenCoffee") + +this.getValue("consts", "directCosts", "acquiring") + +this.getValue("consts", "directCosts", "cropster"));
		// косвенные затраты
		this.setValue("consts", "indirectCosts", "indirectCosts", this.summOfGroup("fields", "indirectCosts") / this.getValue("fields", "production", "actualSales") + this.getValue("fields", "pricing", "plannedSellingPrice") * (this.getValue("fields", "indirectCosts", "marketing") / 100) + this.getValue("fields", "indirectCosts", "buisnesTrips") / (12 * this.getValue("fields", "production", "actualSales")) + this.getValue("fields", "indirectCosts", "borrowedFunds") / (12 * this.getValue("fields", "production", "actualSales")));
		//выводы - производственный лимит
		this.setValue("consts", "summary", "productionLimit", this.getValue("fields", "production", "workingDays") * this.getValue("consts", "production", "kgPerShift"));
		//выводы - фактические продажи
		this.setValue("consts", "summary", "actualSales", this.getValue("fields", "production", "actualSales"));
		// выводы - занятость
		this.setValue("consts", "summary", "busyness", this.getValue("fields", "production", "actualSales") / (this.getValue("fields", "production", "roasterLoading") * 3.2) / 6);
		//выводы - чистая прибыль
		this.setValue("consts", "summary", "profit", this.getValue("fields", "pricing", "plannedSellingPrice") - this.getValue("consts", "pricing", "tax") - this.getValue("consts", "directCosts", "directCosts") - this.getValue("consts", "indirectCosts", "indirectCosts"));
		//выводы - максимальная прибыль
		this.setValue("consts", "summary", "maxProfit", this.getValue("consts", "summary", "profit") * this.getValue("consts", "summary", "productionLimit"));
		//выводы - фактическая прибыль
		this.setValue("consts", "summary", "actualProfit", this.getValue("consts", "summary", "actualSales") * this.getValue("consts", "summary", "profit"));
		// раскраска вывода
		this.setStatus();
	}
}